import React from 'react'
import DataTableStatic from 'components/organisms/data-table-static'
import bankTransactionSelectedTableColumns from './bank-transaction-selected-table-columns'
import PropTypes from 'prop-types'

const propTypes = {
  data            : PropTypes.array,
  handleRemoveRow : PropTypes.func,
  hiddenColumns   : PropTypes.array
}

const defaultProps = {
  data            : [],
  handleRemoveRow : () => {},
  hiddenColumns   : []
}

/**
 * @param {Array<Object>} data - array of ::Finances::BankTransaction objects
 * @param {Function} handleRemoveRow - function to handle callback when checkbox unchecked
 */
const BankTransactionSelectedTable = ({
  data,
  handleRemoveRow,
  hiddenColumns=[]
}) => {

  const selectedBankTransactions = data

  const columns = bankTransactionSelectedTableColumns({
    handleRemoveRow,
    selectedBankTransactions
  })

  return (
    <DataTableStatic
      data={ data }
      hiddenColumns={ hiddenColumns }
      columns={ columns }
    />
  )
}

BankTransactionSelectedTable.propTypes    = propTypes
BankTransactionSelectedTable.defaultProps = defaultProps

export default BankTransactionSelectedTable